<template>
    <div v-if="chat" class="peoples-mesg-box">
        <div class="conversation-head">
            <figure>
                <img :src="extractUser(chat.users).avatar" alt=""/>
            </figure>
            <span>{{ extractUser(chat.users).name }}</span>
            <div class="dropdown options-button">
                <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="true">
                    <i class="fa fa-ellipsis-v"></i>
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
                    <li>
                        <a href="#" @click.prevent="reloadMessages()">
                            {{ autoTranslate ? word.disable_auto_translate : word.enable_auto_translate}}
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="toggleBlock()">
                            {{ chat.blocked ? word.unblock_user : word.block_user }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <ul class="chatting-area" v-chat-scroll>
            <li
                v-for="message in messages"
                :key="message.id"
                :class="{'me' : message.user.id == userId,'you' : message.user.id != userId}"
            >
                <figure>
                    <img
                        :src="message.user.avatar"
                        :alt="message.user.name"
                        :title="message.user.name"
                    />
                </figure>
                <p v-if="message.type === 0">
                    {{ message.text }}
                    <span class="translate-button" v-if="canTranslate(message)"
                          @click="translateSingleMessage(message)">
                        {{ message.translated ? word.see_original : word.see_translate }}
                    </span>
                </p>
                <span class="message-time">{{ message.time }}</span>
            </li>
        </ul>
        <div>
            <div v-for="(user,i) in chat.users" :key="i">
                <div v-if="userWhoIsTypingId && userWhoIsTypingId == user.id">
                    {{ user.name }} {{word.is_typing}}...
                </div>
            </div>
        </div>
        <send-box :chat-id="chat.id" :user-id="userId" :can-not-send-message="chat.blocked"/>
    </div>
</template>

<script>
    import SendBox from "./SendBox";

    export default {
        name: "messages",

        components: {
            SendBox,
        },

        props: [
            'userId'
        ],

        data() {
            return {
                chat: null,
                messages: [],
                whisperTimeout: 0,
                userWhoIsTypingId: null,
                isTranslateAvailable: true,
                autoTranslate: false,
                text: window.text,
                word: window.word
            };
        },

        methods: {
            toggleBlock() {
                let userId = this.extractUser(this.chat.users).id;
                let eventName = this.chat.blocked ? 'UserUnblocked' : 'UserBlocked';
                let routeParameter = this.chat.blocked ? 'unblock' : 'block';

                axios.post(`/en/dashboard/${routeParameter}/${userId}`)
                    .then(() => Bus.$emit(eventName, userId))
                    .catch(error => console.log(error));

                this.chat.blocked = !this.chat.blocked;
            },
            fetchMessages(chatId) {
                axios.get('/en/dashboard/messages', {params: {chat_id: chatId, translate: this.autoTranslate ? 1 : 0}})
                    .then(response => {
                        this.messages = response.data.data;
                    })
                    .catch(error => {
                        console.log(error.response.data)
                    });
            },
            extractUser(users) {
                return users.find(user => {
                    return user.id !== this.userId
                });
            },
            checkTranslationAvailability(chatId) {
                axios.post(`/en/dashboard/translate/${chatId}/check`)
                    .then(response => {
                        this.isTranslateAvailable = response.data.ok;
                    })
                    .catch(error => {
                        console.log(error)
                    });
            },
            reloadMessages() {
                this.autoTranslate = !this.autoTranslate;
                this.fetchMessages(this.chat.id);
            },
            canTranslate(message) {
                return this.isTranslateAvailable && message.user.id != this.userId;
            },
            translateSingleMessage(message) {
                let status = !message.translated;
                let vm = this;
                axios.get(`/dashboard/messages/${message.id}`, {
                    params: {translate: status ? 1 : 0}
                })
                    .then(function (response) {
                        vm.messages.find(item => item.id == message.id).text = response.data.text;
                        vm.messages.find(item => item.id == message.id).translated = status;
                    });
            }
        },

        mounted() {
            Bus.$on('activeChatChanged', (e) => {
                this.autoTranslate = false;
                this.chat = e.chat;
                this.checkTranslationAvailability(e.chat.id);
                this.fetchMessages(e.chat.id)
            });

            Bus.$on('MessageCreated', (message) => {
                this.messages.push(message)
            });

            Bus.$on('MessageReceived', (message) => {
                if (this.chat && message.chat.id === this.chat.id) {
                    this.messages.push(message);
                    if (this.autoTranslate) {
                        this.translateSingleMessage(message);
                    }
                }
            });
        }
    }
</script>

<style scoped>
    .message-time {
        font-size: 10px;
        color: #888;
        margin: 0 5px;
    }

    .translate-button {
        font-size: 10px;
        color: #333;
        background-color: #fff;
        border-radius: 4px;
        margin: 0 10px;
        padding: 2px 4px;
        cursor: pointer;
        opacity: 0.3;
    }

    .translate-button:hover {
        opacity: 0.9;
    }

    .conversation-head {
        position: relative;
        display: flex;
        align-items: center;
    }

    .auto-translate {
        position: absolute;
        top: 20px;
        right: 0;
    }

    .auto-translate input {
        margin-right: 5px;
    }

    .options-button ul {
        padding: 15px;
        width: 250px;
        left:-100px !important;
        right:-200px !important;
    }
</style>
